module.exports = __webpack_public_path__ + "static/img/t55.12e7def6.png";